import {Box, Drawer, Stack, styled, Typography} from '@mui/material';

const StyledDrawer = styled(Drawer)``;

const ImageContainer = styled(Box)`
	position: relative;
	width: 100%;
	display: flex;
	justify-content: center;
`;

const ProgressBarContainer = styled(Box)`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
`;

const DrawerContent = styled(Box)<{$isMobile: boolean}>`
	width: ${({$isMobile}) => ($isMobile ? '100%' : '680px')};
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: ${({$isMobile}) => ($isMobile ? null : 'space-between')};
`;

const ContentStack = styled(Stack)`
	padding: 16px;
	gap: 16px;
	flex-direction: column;
`;

const ButtonStack = styled(Stack)<{$isMobile: boolean}>`
	flex-direction: ${({$isMobile}) => ($isMobile ? 'column-reverse' : 'row')};
	gap: 16px;
	padding: 16px;
	width: 100%;
`;

const ErrorContainer = styled(Box)<{$isMobile: boolean}>`
	display: flex;
	flex-direction: column;
	height: ${({$isMobile}) => ($isMobile ? '80vh' : '100%')};
	justify-content: space-between;
	width: ${({$isMobile}) => ($isMobile ? '100%' : '680px')};
	align-items: center;
`;

const ErrorButtonStack = styled(Stack)<{$isMobile: boolean}>`
	flex-direction: ${({$isMobile}) => ($isMobile ? 'column-reverse' : 'row')};
	gap: 16px;
	padding: 16px;
	width: 100%;
`;

const QuestionStack = styled(Stack)``;

const QuestionTypography = styled(Typography)<{$isMobile: boolean}>`
	padding: ${({$isMobile}) => ($isMobile ? '0 16px 16px' : '16px')};
	font-weight: 600;
`;

const StyledImage = styled('img')`
	max-height: 366px;
	object-fit: cover;
	width: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		max-height: 350px;
	}
`;

export {
	ButtonStack,
	ContentStack,
	DrawerContent,
	ErrorButtonStack,
	ErrorContainer,
	ImageContainer,
	ProgressBarContainer,
	QuestionStack,
	QuestionTypography,
	StyledDrawer,
	StyledImage,
};
